module.exports = __webpack_public_path__ + "assets/Allergien.6a3d2a7b.png";